var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"text"},[_vm._v("\n        이벤트 참여자만 플레이 가능합니다.\n    ")]),_vm._v(" "),_c('div',{staticClass:"confirm",on:{"click":_vm.goToEventPage}},[_vm._v("\n        응모하러 가기\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a8d40a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/runner/Modal5.vue
// module id = null
// module chunks = 